<template>
  <transition name="modal">
    <div :class="['modal-mask', { 'fullscreen': fullscreen }]">
      <div class="modal-wrapper">
        <div v-on-clickaway="close" class="modal-container">
          <component :is="component"
            v-bind="props"
            :asModal="true" />
        </div>
      </div>
    </div>
  </transition>

</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
import style from 'brave-routing/components/brave-modal.scss'
  export default {
    mixins: [clickaway],
    name: 'brave-modal',
    methods: {
      close: function () {

        this.$store.dispatch('popModal')
      }
    },
    props: {
      component: Object,
      props: Object,
      fullscreen: Boolean // New prop for fullscreen
    }
  }
</script>